var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgSocialTt = function SvgSocialTt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tt",
    clipPath: "url(#clip0_1639_582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0725 0.505859H13.0278V16.8537C13.0278 18.8015 11.4722 20.4015 9.53626 20.4015C7.60034 20.4015 6.04469 18.8015 6.04469 16.8537C6.04469 14.9407 7.56577 13.3754 9.43257 13.3059V9.20153C5.31872 9.27106 2 12.645 2 16.8537C2 21.0972 5.38786 24.5059 9.57085 24.5059C13.7538 24.5059 17.1416 21.0624 17.1416 16.8537V8.47106C18.6627 9.58413 20.5295 10.245 22.5 10.2798V6.17543C19.4579 6.07108 17.0725 3.56673 17.0725 0.505859Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1639_582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.505859)"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgSocialTt);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/social-tt.b74692b1f8f9945840af8f8cf7d8eeca.svg";